import React from 'react'
import ProjectManagement from '../components/ProjectManagement'
const GeneralInfo = ({ setStep }) => {
  return (
    <ProjectManagement setStep={setStep} />
  )
}

export default GeneralInfo
